import React from "react";
import styled from "styled-components";

// Utility function to process data for chart visualization
export const getSeries = (data) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  
  // Process the data into chart series format
  // Process data for chart visualization
  return data.map((item, index) => ({
    name: item.name || `Series ${index + 1}`,
    data: item.data || [0, 0, 0, 0, 0, 0, 0]
  }));
};

const LineChart = () => {
  return (
    <Container>
      <Title>Patient Event Metrics</Title>
      <ChartPlaceholder>
        <ChartText>📊 Patient Metrics</ChartText>
        <ChartText>Data visualization</ChartText>
      </ChartPlaceholder>
    </Container>
  );
};

export default LineChart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  max-width: 400px;
`;

const Title = styled.h3`
  color: #333;
  margin-bottom: 15px;
  font-size: 18px;
`;

const ChartPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 2px dashed #dee2e6;
  width: 100%;
`;

const ChartText = styled.p`
  margin: 5px 0;
  color: #666;
  font-size: 14px;
`;